<template>
    <div class="login-container">
<!--        <div class="header-title"><div style="display:table-cell;vertical-align:middle"><img src="../../assets/images/header-title.png" width="200px"></div></div>-->
        <div class="loginContent">
            <el-form
                ref="loginForm"
                :model="loginForm"
                class="login-form"
                auto-complete="on"
                label-position="left"
            >
                <div class="login-title"> {{baseTitle}} </div>
                <div style="padding: 30px 30px 0px 30px">
                <el-form-item prop="username">
                    <span class="svg-container">
                        <i class="iconfont icon-yonghu"></i>
                    </span>
                    <el-input
                        ref="username"
                        v-model="loginForm.username"
                        autocomplete="off"
                        placeholder="用户账号"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <span class="svg-container">
                        <i class="iconfont icon-mima"></i>
                    </span>
                    <el-input
                        ref="password"
                        v-model="loginForm.password"
                        autocomplete="off"
                        :type="passwordType"
                        @keyup.native="handleKeyLogin"
                        placeholder="用户密码"
                    ></el-input>
                    <span class="show-pwd" @click="changetype" >
                        <i
                            class="iconfont"
                            :class="passwordType == 'password'? 'icon-guanbi':'icon-xianshimima'"
                        ></i>
                    </span>
                </el-form-item>
                <el-button
                    :loading="loading"
                    type="primary"
                    style="width:100%;margin-bottom:30px;margin-top: 30px"
                    @click.native.prevent="handleLogin"
                >登录</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import ElFormItem from "element-ui/packages/form/src/form-item";
import ElInput from "element-ui/packages/input/src/input";

export default {
    components: {
        ElInput,
        ElFormItem},
    name: "index",
    data() {
        return {
            baseTitle: '',
            passwordType: 'password',
            loginForm: {
                username: '',
                password: '',
            },
            loginRules: {
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            loading: false,
        }
    },
    mounted() {
        this.getInfo(); //初始化
        if (this.$route.query.token) {
            this.loginForm.username = 'admin';
            this.loginForm.password = '';
            this.loginForm.token = this.$route.query.token;
            this.handleJumpHomePage();
        }
    },
    methods: {
        // 切换显示方式
        changetype() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
        },
        handleLogin() {//点击登录
            this.handleJumpHomePage();
        },
        handleKeyLogin(e) { //回车登录
            if (e.keyCode == 13) {
                this.handleJumpHomePage();
            }
        },
        getInfo() { //获取详情
            this.$api.post('setting/getSetting', { k: 'site' }, res => {
                if (res.code == 0) {
                    this.baseTitle = res.data.site_title;
                    document.title = res.data.site_title;
                    sessionStorage.setItem('title', res.data.site_title);
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleJumpHomePage() { //处理跳转首页
            this.$api.post('login', this.loginForm, res => {
                if (res.code == 0) {
                    let that = this;
                    let data = res.data;
                    sessionStorage.setItem('is_admin', data.is_admin);
                    sessionStorage.setItem('token', data.token);
                    sessionStorage.setItem('level', data.info.level);
                    sessionStorage.setItem('company', data.info.level == 0 ? data.info.realname : data.info.nickname);
                    sessionStorage.setItem('real_name', data.info.real_name);
                    sessionStorage.setItem('has_update_password', data.info.has_update_password);
                    sessionStorage.setItem('login_count', data.info.login_count);
                    sessionStorage.setItem('is_company', data.info.is_company);
					
					if(data.info.agent_no){
						sessionStorage.setItem('agent_no', data.info.agent_no);
					}
                    if(data.info.username==undefined){
                        sessionStorage.setItem('username', data.info.phone);
                    }else{
                        sessionStorage.setItem('username', data.info.username);
                    }
                    sessionStorage.setItem('repayment_type', data.repayment_type);
                    sessionStorage.setItem('admin_id', data.info.id);
                    this.$message({
                        type: 'success',
                        message: '登录成功',
                        duration: 1000,
                        onClose() {
                            // that.$router.push({ path: '/' });
                            location.href = '/'
                            // is_update_password 1.需求修改 2.无需修改
                            if (res.data.info.is_update_password == 2) {
                                that.$alert('系统检测到您的登录密码还是初始密码，为了您的账号安全请尽快修改登录密码!', '温馨提示', {
                                    type: 'warning',
                                    center: true,
                                    confirmButtonText: '去修改',
                                    confirmButtonClass: 'apply-button',
                                    callback: action => {
                                        if (action === 'confirm') {
                                            that.$router.push({ path: '/editPassword' });
                                        }
                                    }
                                });
                            }
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.login-container {
    height: 100%;
    background-image: url("../../assets/images/bg3.jpg");
    // background-color: #d3048ee3;
    background-size: 100% 100%;
    position: relative;
    .loginContent {
        width: 350px;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-44%, -50%);
    }
    .header-title{
        text-align: center;
        display:table;
        height: 12%;
        margin: 0 auto;
    }
    .login-form {
        .login-title {
            font-family:"Microsoft YaHei";
            font-size: 28px;
            text-align: center;
            margin-bottom: 30px;
            letter-spacing: 5px;
            color: white;
        }
       .login-titles {
            font-family:"Microsoft YaHei";
            text-align: center;
            font-size: 16px;
            margin-bottom: 30px;
            color: white;
       }
        .el-form-item {
            border: 1px solid;
            //background: rgba(0, 0, 0, 0.5);
            border-radius: 5px;
            color: #454545;
            background-color: white;
        }
        .svg-container {
            padding: 0px 0px 0px 7.5px;
            color: #666;
            vertical-align: middle;
            //display: inline-block;
        }
        .show-pwd {
            position: absolute;
            right: 14px;
            top: 2px;
            color: #333;
            cursor: pointer;
            user-select: none;
            .iconfont {
                font-size: 20px;
            }
        }
    }
    .el-form-item {
        margin-bottom: 22px;
    }
}
</style>